import { getUserDataQuerySelector } from "../common/apis/selectors";
import { LocalStorageKey } from "../common/constants/keys";
import { coreApi } from "./connections";

export async function validateLocalToken() {
  try {
    const auth = localStorage.getItem(LocalStorageKey.Auth);

    if (!auth) {
      throw new Error("No token found");
    }

    // Check if the token is expired
    if (isJwtExpired(auth)) {
      throw new Error("Token expired");
    }

    coreApi.defaults.headers.common["Authorization"] = `Bearer ${auth}`;

    // const data = await getDataOrNull(getUserDataQuery);

    const data = await getUserDataQuerySelector();

    if (!data) {
      throw new Error("Invalid token");
    }

    return data;
  } catch (error) {
    delete coreApi.defaults.headers.common["Authorization"];
    localStorage.clear();
  }

  return null;
}

export function isJwtExpired(token: string): boolean {
  try {
    const [, payloadBase64] = token.split(".");
    const payload = JSON.parse(atob(payloadBase64));
    const exp = payload.exp;
    if (!exp) return false;
    return Date.now() >= exp * 1000;
  } catch (e) {
    return false;
  }
}
